import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import { generateTraceparent } from '@zeusm/shared/core/helpers';

/** Adds a W3C traceparent header to each outgoing request. */
export function traceInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  return next(request.clone({ setHeaders: { traceparent: generateTraceparent() } }));
}
